import { connect } from "react-redux";
import { toggle } from "common/ducks/tour";
import Tour from "common/components/tour";

export default connect(undefined, {
  toggle,
})(Tour);
